import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import PropertySlider from "./components/PropertySlider";
import PropertyIntro from "./components/PropertyIntro";
import Properties from "./components/Properties";
import PropertySingle from "./components/property-single/PropertySingle";
import Condominium from "./components/condominium/Condominium";
import Footer from "./components/Footer";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

function App() {
  const { pathname } = useLocation();
  const isPropertySinglePage = pathname === "/property-single";

  return (
    <div className={`App${isPropertySinglePage ? " property-single-layout" : ""}`}>
      <Header />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Hero />
              <PropertySlider />
              <PropertyIntro />
            </>
          }
        />
        <Route path="/properties" element={<Properties />} />
        <Route path="/properties.html" element={<Properties />} />
        <Route path="/property-single" element={<PropertySingle />} />
        <Route path="/condominium" element={<Condominium />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer showMore={pathname === "/"} />
    </div>
  );
}

export default App;
